export default __webpack_public_path__ + "static/kubernetes-7bec2a681e1d42d6dc0431d6dd57a7e7.png";